export default function StatWidget({
    label,
    value,
    icon = null,
    change = null,
    changeLabel = '',
    variant = 'default', // default, primary, success, warning, danger, info
    size = 'default', // default, compact
    className = ''
}) {
    const formatValue = (val) => {
        if (typeof val === 'number') {
            return val.toLocaleString();
        }
        return val;
    };

    const variants = {
        default: {
            icon: 'stat-widget-icon',
            accent: ''
        },
        primary: {
            icon: 'stat-widget-icon icon-primary',
            accent: 'accent-primary'
        },
        success: {
            icon: 'stat-widget-icon icon-success',
            accent: 'accent-success'
        },
        warning: {
            icon: 'stat-widget-icon icon-warning',
            accent: 'accent-warning'
        },
        danger: {
            icon: 'stat-widget-icon icon-danger',
            accent: 'accent-danger'
        },
        info: {
            icon: 'stat-widget-icon icon-info',
            accent: 'accent-info'
        }
    };

    const currentVariant = variants[variant] || variants.default;

    return (
        <div className={`stat-widget ${size === 'compact' ? 'stat-widget-compact' : ''} ${className}`}>
            <div className="stat-widget-inner">
                <div className="stat-widget-content">
                    <span className="stat-widget-label">{label}</span>
                    <div className="stat-widget-value">{formatValue(value)}</div>
                    {change !== null && (
                        <div className={`stat-widget-change ${change >= 0 ? 'positive' : 'negative'}`}>
                            <i className={`bi ${change >= 0 ? 'bi-trending-up' : 'bi-trending-down'}`}></i>
                            <span>{change >= 0 ? '+' : ''}{change}%</span>
                            {changeLabel && <span className="change-label">{changeLabel}</span>}
                        </div>
                    )}
                </div>
                {icon && (
                    <div className={currentVariant.icon}>
                        <i className={`bi ${icon}`}></i>
                    </div>
                )}
            </div>
            {variant !== 'default' && <div className={`stat-widget-accent ${currentVariant.accent}`}></div>}
        </div>
    );
}

// Grid wrapper for multiple stats
export function StatWidgetGrid({ children, columns = 4, className = '' }) {
    return (
        <div className={`stat-widget-grid cols-${columns} ${className}`}>
            {children}
        </div>
    );
}
